import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { HospitalityContent } from '@/pageContents/hospitality/HospitalityContent';
import { Permission } from '@/models/user';

const HospitalityPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Hospitality | Starjack Backoffice</title>
            </Helmet>

            <HospitalityContent newOrEditMode={false} />
        </>
    );
};

HospitalityPage.isProtected = true;
HospitalityPage.permissions = [Permission.HOSPITALITY_NAV];
HospitalityPage.getLayout = (Component) => (
    <SidebarLayout>{Component}</SidebarLayout>
);

export default HospitalityPage;
